import type { RouteRecordRaw } from "vue-router";
/**
 * @name 获取浏览器默认语言
 * @returns {String}
 */
export function getBrowserLang() {
	return navigator.language ? navigator.language : navigator.browserLanguage;
}

/**
 * @name 递归扁平化菜单
 * @description 将嵌套路由转为一级路由，使`keep-alive`生效
 * @param {Array} menuList 菜单列表
 * @returns {Array}
 */
export function getFlatMenuList(menuList: RouteRecordRaw[]): RouteRecordRaw[] {
	const newMenuList: RouteRecordRaw[] = menuList;
	return newMenuList.flatMap(item => [item, ...(item?.children ? getFlatMenuList(item?.children) : [])]);
}

export function generateRandomNumberBetween(min: number, max: number) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * 给金额加上千分号
 */
export const formatAmount = (amount?: number, fractionDigits: number = 2) => {
	if (typeof amount !== "number") {
		return undefined;
	}
	return amount.toFixed(fractionDigits).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export function formatStringToHex(domain: string): string {
	return Array.from(new TextEncoder().encode(domain))
		.map(byte => byte.toString(16).padStart(2, "0"))
		.join("");
}

export function loadExternalAssets({
	scripts = [],
	styles = []
}: {
	scripts?: string[];
	styles?: string[]; // 注意：这里是 CSS 内容，不是 href
}) {
	return new Promise<void>((resolve, reject) => {
		let loadedCount = 0;
		const total = scripts.length + styles.length;

		if (total === 0) {
			resolve();
			return;
		}

		const checkDone = () => {
			loadedCount++;
			if (loadedCount === total) {
				resolve();
			}
		};

		// 插入 <style> 标签
		styles.forEach(styleContent => {
			const styleEl = document.createElement("style");
			styleEl.type = "text/css";
			styleEl.textContent = styleContent;
			document.head.appendChild(styleEl);
			checkDone();
		});

		// 动态加载 <script>
		scripts.forEach(src => {
			const script = document.createElement("script");
			script.src = src;
			script.async = true;
			script.onload = checkDone;
			script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
			document.body.appendChild(script);
		});
	});
}
